<template>
  <div class="activity-info-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>音乐版本管理</h2>
    </div>

    <!-- 查询表单 -->
    <el-form :inline="true" class="query-form">
      <el-form-item>
        <el-button type="success" icon="el-icon-plus" @click="handleAdd">
          新增
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 数据表格 -->
    <el-table
      v-loading="loading"
      :data="versionList"
      border
      stripe
      height="700"
      style="width: 100%"
    >
      <el-table-column label="序号" width="80" align="center" type="index">
        <template slot-scope="scope">
          {{scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column prop="versionCode" label="版本号" width="200" align="center"/>
      <el-table-column prop="versionName" label="版本名称" width="200" align="center"/>
      <el-table-column prop="releaseNotes" label="版本描述" align="center"/>
      <el-table-column prop="type" label="状态" width="200" align="center">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.status === '0'">生效</el-tag>
          <el-tag type="danger" v-else>失效</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="createTimeStr" label="创建时间" align="center"/>
      <el-table-column label="操作" width="200" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="handleEdit(scope.row)">
            编辑
          </el-button>
          <el-button
            type="text"
            icon="el-icon-edit"
            @click="handleUpload(scope.row)">
            升级版本
          </el-button>
          <el-button
            type="text"
            icon="el-icon-delete"
            style="color: #f56c6c"
            @click="handleDelete(scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加/编辑对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
      @close="handleDialogClose"
    >
      <el-form
        ref="activityForm"
        :model="form"
        :rules="formRules"
        label-width="120px"
      >
        <el-form-item label="版本名称" prop="versionName">
          <el-input v-model="form.versionName"></el-input>
        </el-form-item>
        <el-form-item label="版本描述" prop="releaseNotes">
          <el-input type="textarea"
                    :rows="2" v-model="form.releaseNotes"></el-input>
        </el-form-item>
        <el-form-item label="活动类型" prop="status">
          <el-radio-group v-model="form.status">
            <el-radio label="0">生效</el-radio>
            <el-radio label="1">失效</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="APP" prop="downloadUrl">
          <el-upload
              ref="imgBroadcastUpload"
              :limit="1"
              :auto-upload="true"
              :file-list="fileList"
              :on-success="addPic"
              :before-upload="beforeUpload"
              list-type="picture-card"
              accept=".apk"
              :action="uploadurl">
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div slot="tip" class="el-upload__tip">只能上传apk文件，且不超过50M</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ActivityInfo',
  data() {
    return {
      ossURL: this.ossURL,
      // 活动列表
      versionList: [],
      // 总记录数
      total: 0,
      // 加载状态
      loading: false,
      // 对话框显示状态
      dialogVisible: false,
      // 对话框标题
      dialogTitle: '',
      // 提交加载状态
      submitLoading: false,
      // 活动表单
      form: {
        id: null,
        versionName: null,
        releaseNotes: null,
        downloadUrl: null,
        status: '0'
      },
      // 表单验证规则
      formRules: {
        versionName: [
          { required: true, message: '请输入版本名称', trigger: 'blur' }
        ],
        downloadUrl: [
          { required: true, message: '请上传APP文件', trigger: 'change' }
        ]
      },
      fileList: [],
      uploadurl: this.GLOBAL.imgURL+'uploadApp/',
    }
  },
  created() {
    this.getActivityList()
  },
  methods: {
    // 获取活动列表
    getActivityList() {
      this.loading = true

      // 使用 axios 发送请求
      this.$http.get('/musicVersion/list')
        .then(response => {
          let data = response.data;
          if (data.code === 200) {
            this.versionList = data.data || []
          } else {
            this.$message.error(data.msg || '获取版本列表失败')
          }
        })
        .catch(error => {
          console.error('获取版本列表失败:', error)
          this.$message.error('获取版本列表失败，请稍后重试')
        })
        .finally(() => {
          this.loading = false
        })
    },

    // 新增
    handleAdd() {
      this.dialogTitle = '新增版本'
      this.dialogVisible = true
      this.form = {
        id: null,
        versionName: null,
        releaseNotes: null,
        downloadUrl: null,
        status: '0'
      }
      this.fileList = []
    },

    // 编辑
    handleEdit(row) {
      this.dialogTitle = '编辑版本'
      this.dialogVisible = true

      this.form = {
        id: row.id,
        versionName: row.versionName,
        releaseNotes: row.releaseNotes,
        downloadUrl: row.downloadUrl,
        status: row.status
      }
      this.fileList = [{name:row.downloadUrl,url:this.ossURL+row.downloadUrl}]
    },

    // 升级当前版本
    handleUpload(row) {
      let that = this
      this.$confirm('是否确认升级音乐库版本' + row.versionCode + '？').then(function() {
        that.$http.post('/mqtt/operatorUpdateMusicVersion',{versionCode: row.versionCode}).then(_ => {
          that.$message.success('升级成功，请等待软件升级')
        })
      });
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确定要删除该版本吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$http.get('/musicVersion/delete/' + row.id)
            .then(response => {
              if (response.data.status === 0) {
                this.$message.success('删除成功')
                this.getActivityList()
              } else {
                this.$message.error(response.data.msg || '删除失败')
              }
            })
            .catch(error => {
              console.error('删除失败:', error)
              this.$message.error('删除失败，请稍后重试')
            })
            .finally(() => {
              this.loading = false
            })
        })
        .catch(() => {
          // 用户取消删除
        })
    },

    // 提交表单
    handleSubmit() {
      this.$refs.activityForm.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const url = this.form.id ? '/musicVersion/update' : '/musicVersion/add'

          this.$http.post(url, this.form)
            .then(response => {
              if (response.data.code === 200) {
                this.$message.success(this.form.id ? '更新成功' : '添加成功')
                this.dialogVisible = false
                this.getActivityList()
              } else {
                this.$message.error(response.data.msg || '操作失败')
              }
            })
            .catch(error => {
              console.error('操作失败:', error)
              this.$message.error('操作失败，请稍后重试')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          this.$message.warning('请填写完整的表单信息')
          return false
        }
      })
    },

    // 对话框关闭
    handleDialogClose() {
      this.$refs.activityForm.resetFields()
    },

    addPic(file){
      if (file.code == '0') {
        this.form.downloadUrl = file.url
      } else {
        this.$message.error(file.msg);
      }
    },
    beforeUpload(file) {
      // 可选：还可以在这里校验文件类型、大小等
      const isValidType = file.name.endsWith('apk');
      const isValidSize = file.size / 1024 / 1024 < 51; // 小于 51MB

      if (!isValidType) {
        this.$message.error('只能上传 APK 格式的文件！');
        return false;
      }
      if (!isValidSize) {
        this.$message.error('文件大小不能超过 50MB！');
        return false;
      }

      return true; // 允许上传
    }
  }
}
</script>

<style scoped>
.activity-info-container {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 24px;
  color: #303133;
}

.query-form {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.el-table {
  background: #fff;
}

.dialog-footer {
  text-align: right;
}
</style>
